import { useEffect } from 'react';

export const useHideWaitingPage = (loading, idName) => {
  useEffect(() => {
    if (!loading) {
      const waitingPage = document.getElementById(idName);
      if (waitingPage) {
        waitingPage.style.display = 'none';
      }
    }
  }, [loading, idName]);
};
